import { ResourceState } from './resource-state';

export class ResourceData {
  saveId = '';
  data: Blob | File = new Blob();
  fileId = ''; //zeitstempel + extension
  state = ResourceState.Unchanged;
  orderId = '';
}
